var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path17, _g, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path18, _g2, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _path19, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0854 19.7973C23.576 26.1226 16.792 28.9813 11.928 26.176C7.06402 23.3706 5.96535 15.968 9.47469 9.63196C12.984 3.29596 18.3174 -0.682706 24.632 3.25329C29.3894 6.22929 30.5947 13.472 27.0854 19.7973Z",
    fill: "url(#paint0_linear_302_701)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6987 19.2213C22.1893 25.5466 15.4053 28.4053 10.5413 25.5999C5.67733 22.7946 4.57866 15.3919 8.088 9.05594C11.5973 2.71994 18.3813 -0.128056 23.2453 2.67728C28.1093 5.48261 29.208 12.8959 25.6987 19.2213Z",
    fill: "url(#paint1_linear_302_701)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.624 19.2213C22.1147 25.5466 15.3307 28.4053 10.4667 25.5999C5.60268 22.7946 4.50402 15.3919 8.01335 9.05594C11.5227 2.71994 18.3067 -0.128056 23.1707 2.67728C28.0347 5.48261 29.1334 12.8959 25.624 19.2213Z",
    fill: "url(#paint2_linear_302_701)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5493 19.1787C22.04 25.504 15.256 28.3627 10.392 25.5573C5.52801 22.752 4.42934 15.3493 7.93867 9.01334C11.448 2.67734 18.232 -0.170658 23.096 2.63467C27.96 5.44001 29.0587 12.8533 25.5493 19.1787Z",
    fill: "url(#paint3_linear_302_701)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4373 17.8453C20.4613 23.2106 14.7867 25.6746 10.7653 23.36C6.74401 21.0453 5.90134 14.8053 8.87734 9.45064C11.8533 4.09597 17.528 1.62131 21.5493 3.93597C25.5707 6.25064 26.4133 12.48 23.4373 17.8453Z",
    fill: "url(#paint4_linear_302_701)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1547 16.6186C18.8827 20.7146 14.552 22.6026 11.48 20.8319C8.408 19.0613 7.768 14.3039 10.04 10.2079C12.312 6.11194 16.6427 4.22395 19.7147 5.99461C22.7867 7.76528 23.4267 12.5226 21.1547 16.6186Z",
    fill: "url(#paint5_linear_302_701)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6027 16.7467C19.3307 20.8427 15 22.7307 11.928 20.96C8.856 19.1893 8.216 14.432 10.488 10.336C12.76 6.24 17.0907 4.352 20.1627 6.12266C23.2347 7.89333 23.8747 12.6507 21.6027 16.7467Z",
    fill: "url(#paint6_linear_302_701)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3254 16.6613C19.0534 20.7573 14.7227 22.6453 11.6507 20.8747C8.57869 19.104 7.93869 14.3467 10.2107 10.2507C12.4827 6.15467 16.8134 4.26667 19.8854 6.03734C22.9574 7.808 23.5974 12.5653 21.3254 16.6613Z",
    fill: "url(#paint7_linear_302_701)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3254 16.6613C19.0534 20.7573 14.7227 22.6453 11.6507 20.8747C8.57869 19.104 7.93869 14.3467 10.2107 10.2507C12.4827 6.15467 16.8134 4.26667 19.8854 6.03734C22.9574 7.808 23.5974 12.5653 21.3254 16.6613Z",
    fill: "url(#paint8_linear_302_701)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4213 16.768C19.1493 20.864 14.8187 22.752 11.7467 20.9814C8.67467 19.2107 8.03467 14.4534 10.3067 10.3574C12.5787 6.26136 16.92 4.37336 19.992 6.14403C23.064 7.91469 23.704 12.672 21.4213 16.768Z",
    fill: "url(#paint9_linear_302_701)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.32 15.5093C17.656 18.4959 14.5627 19.9039 12.3974 18.6559C10.232 17.4079 9.81602 13.9626 11.48 10.9759C13.144 7.98927 16.2374 6.58127 18.4027 7.82927C20.568 9.07727 20.9734 12.5226 19.32 15.5093Z",
    fill: "url(#paint10_linear_302_701)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8133 14.016C15.96 15.552 14.3707 16.288 13.2613 15.6373C12.152 14.9867 11.9493 13.2267 12.8027 11.6907C13.656 10.1547 15.2453 9.41868 16.3547 10.0693C17.4533 10.7093 17.6667 12.4693 16.8133 14.016Z",
    fill: "url(#paint11_linear_302_701)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.208 14.1227C16.3547 15.6587 14.7653 16.3947 13.656 15.744C12.5467 15.104 12.344 13.3334 13.1973 11.7974C14.0507 10.2614 15.64 9.52536 16.7493 10.176C17.8587 10.816 18.0613 12.5867 17.208 14.1227Z",
    fill: "url(#paint12_linear_302_701)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9307 14.048C16.0774 15.584 14.488 16.32 13.3787 15.6693C12.2694 15.0293 12.0667 13.2587 12.92 11.7227C13.7734 10.1867 15.3627 9.45066 16.472 10.1013C17.5707 10.7413 17.784 12.5013 16.9307 14.048Z",
    fill: "url(#paint13_linear_302_701)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9307 14.048C16.0774 15.584 14.488 16.32 13.3787 15.6693C12.2694 15.0293 12.0667 13.2587 12.92 11.7227C13.7734 10.1867 15.3627 9.45066 16.472 10.1013C17.5707 10.7413 17.784 12.5013 16.9307 14.048Z",
    fill: "url(#paint14_linear_302_701)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.016 14.0694C16.1627 15.6054 14.5733 16.3414 13.464 15.6907C12.3547 15.0507 12.152 13.28 13.0053 11.744C13.8587 10.208 15.448 9.47202 16.5573 10.1227C17.6667 10.7627 17.8693 12.5334 17.016 14.0694Z",
    fill: "url(#paint15_linear_302_701)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.8,
    y: 10.6666,
    width: 2.98667,
    height: 2.45333,
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.73334,
    y: 4.69324,
    width: 3.41333,
    height: 2.45333,
    fill: "url(#pattern1)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.58667,
    y: 3.73328,
    width: 2.88,
    height: 2.77333,
    fill: "url(#pattern2)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.48001,
    y: 4.58655,
    width: 6.50667,
    height: 5.12,
    fill: "url(#pattern3)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.85333,
    y: 7.67981,
    width: 0.96,
    height: 1.06667,
    fill: "url(#pattern4)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.49335,
    y: 8.21326,
    width: 1.49333,
    height: 1.49333,
    fill: "url(#pattern5)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_302_701",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 4,
    height: 4
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.152 10.1972C12.0773 10.1332 11.5973 9.82383 10.8613 9.34383C10.1253 8.86383 9.89067 8.6825 9.89067 8.6825C9.74134 8.82116 9.61334 8.9705 9.50667 9.10916C9.40001 9.24783 9.29334 9.41849 9.20801 9.59983C9.20801 9.59983 9.45334 9.77049 10.1253 10.3465C10.7973 10.9118 11.2347 11.2745 11.3093 11.3385C11.384 11.4025 11.5867 11.3385 11.672 11.4238C11.672 11.4238 11.9067 11.3172 12.0987 11.0612L12.1093 11.0505L12.12 11.0398C12.312 10.7732 12.344 10.5278 12.344 10.5278C12.2267 10.4638 12.2267 10.2505 12.152 10.1972Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_302_701)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.13333,
    y: 8.63977,
    width: 3.2,
    height: 2.88,
    fill: "url(#pattern6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.424 8.33044L10.4987 8.38378C10.264 8.53311 9.96534 8.81044 9.66667 9.20511C9.37867 9.59978 9.19734 9.97311 9.12267 10.2398L9.048 10.1864C9.13334 9.88778 9.34667 9.50378 9.592 9.15178C9.85867 8.81044 10.1573 8.50111 10.424 8.33044ZM9.77334 9.29044C9.51734 9.63178 9.31467 10.0158 9.22934 10.3251L9.304 10.3784C9.368 10.1118 9.54934 9.73844 9.848 9.34378C10.136 8.94911 10.4453 8.66111 10.68 8.52244L10.6053 8.46911C10.3387 8.62911 10.0293 8.93844 9.77334 9.29044ZM9.95467 9.40778C9.69867 9.74911 9.496 10.1331 9.41067 10.4424L9.48534 10.4958C9.54934 10.2291 9.73067 9.85578 10.0293 9.46111C10.3173 9.06644 10.6267 8.77844 10.8613 8.63978L10.7867 8.58644C10.5093 8.75711 10.2 9.06644 9.95467 9.40778Z",
    fill: "url(#paint16_linear_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4453 8.34119L10.52 8.39452C10.2853 8.54385 9.98667 8.82119 9.688 9.21585C9.4 9.61052 9.21867 9.98385 9.144 10.2505L9.06934 10.1972C9.15467 9.89852 9.368 9.51452 9.61334 9.16252C9.86934 8.83185 10.1787 8.52252 10.4453 8.34119ZM9.79467 9.30119C9.53867 9.64252 9.336 10.0265 9.25067 10.3359L9.32534 10.3892C9.38934 10.1225 9.57067 9.74919 9.86934 9.35452C10.1573 8.95985 10.4667 8.67185 10.7013 8.53319L10.6267 8.47985C10.3493 8.63985 10.0507 8.95985 9.79467 9.30119ZM9.96534 9.42919C9.70934 9.77052 9.50667 10.1545 9.42134 10.4639L9.496 10.5172C9.56 10.2505 9.74134 9.87719 10.04 9.48252C10.328 9.08785 10.6373 8.79985 10.872 8.66119L10.7973 8.60785C10.5307 8.76785 10.2213 9.08785 9.96534 9.42919Z",
    fill: "url(#paint17_linear_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6507 10.6877C11.3947 11.0291 11.0853 11.3384 10.8187 11.5091L10.744 11.4557C10.9787 11.3171 11.288 11.0398 11.576 10.6451C11.8747 10.2504 12.056 9.88775 12.1307 9.62108L12.2053 9.67442C12.12 9.96242 11.9067 10.3464 11.6507 10.6877ZM12.0347 9.53575L11.96 9.48242C11.8853 9.74908 11.704 10.1118 11.4053 10.5064C11.1067 10.9011 10.808 11.1784 10.5733 11.3171L10.648 11.3704C10.9147 11.1998 11.224 10.8904 11.48 10.5491C11.736 10.2184 11.9493 9.83442 12.0347 9.53575ZM11.864 9.39708L11.7893 9.34375C11.7147 9.61042 11.5333 9.97308 11.2347 10.3677C10.936 10.7624 10.6373 11.0398 10.4027 11.1784L10.4773 11.2318C10.744 11.0611 11.0533 10.7517 11.3093 10.4104C11.5653 10.0904 11.7787 9.70642 11.864 9.39708Z",
    fill: "url(#paint18_linear_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6293 10.6665C11.3733 11.0078 11.064 11.3171 10.7973 11.4878L10.7227 11.4345C10.9573 11.2958 11.2667 11.0185 11.5547 10.6238C11.8533 10.2291 12.0347 9.86646 12.1093 9.5998L12.184 9.65313C12.0987 9.9518 11.8853 10.3251 11.6293 10.6665ZM12.0133 9.51446L11.9387 9.46113C11.864 9.7278 11.6827 10.0905 11.384 10.4851C11.0853 10.8798 10.7867 11.1571 10.552 11.2958L10.6267 11.3491C10.8933 11.1785 11.2027 10.8691 11.4587 10.5278C11.7147 10.1971 11.928 9.8238 12.0133 9.51446ZM11.8427 9.38646L11.768 9.33313C11.6933 9.5998 11.512 9.96246 11.2133 10.3571C10.9147 10.7518 10.616 11.0291 10.3813 11.1678L10.456 11.2211C10.7227 11.0505 11.032 10.7411 11.288 10.3998C11.544 10.0691 11.7573 9.68513 11.8427 9.38646Z",
    fill: "url(#paint19_linear_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.584 9.95183C9.74134 9.27983 8.97334 8.85316 8.856 8.99183C8.73867 9.1305 9.336 9.79183 10.168 10.4638C11.0107 11.1358 11.7787 11.5625 11.896 11.4238C12.0133 11.2745 11.416 10.6238 10.584 9.95183Z",
    fill: "url(#paint20_radial_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5413 9.99447C9.752 9.36514 9.02667 8.93848 8.94134 9.05581C8.84534 9.17314 9.42134 9.78114 10.2107 10.4105C11 11.0398 11.7253 11.4665 11.8107 11.3491C11.9067 11.2318 11.3307 10.6345 10.5413 9.99447Z",
    fill: "url(#paint21_radial_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0453 11.0184C11.5013 10.8691 11.032 10.9011 10.9787 11.0718C10.936 11.2424 11.3307 11.5091 11.8747 11.6478C12.4187 11.7864 12.888 11.7651 12.9413 11.5944C12.984 11.4238 12.5893 11.1678 12.0453 11.0184Z",
    fill: "url(#paint22_radial_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.024 11.0717C11.512 10.9331 11.0747 10.9437 11.032 11.0824C10.9893 11.2211 11.3733 11.4557 11.8853 11.5944C12.3973 11.7331 12.8347 11.7224 12.8774 11.5837C12.92 11.4451 12.536 11.2104 12.024 11.0717Z",
    fill: "url(#paint23_radial_302_701)"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3.58667,
    y: 9.49329,
    width: 12.3733,
    height: 4.26667,
    fill: "url(#pattern7)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.79999,
    y: 12.16,
    width: 12.2667,
    height: 4.69333,
    fill: "url(#pattern8)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 6.67999,
    y: 3.83997,
    width: 9.06667,
    height: 10.1333,
    fill: "url(#pattern9)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8667,
    y: 9.81335,
    width: 1.92,
    height: 3.30667,
    fill: "url(#pattern10)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 7.10669,
    y: 0.746704,
    width: 2.45333,
    height: 3.2,
    fill: "url(#pattern11)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 8.17337,
    width: 2.13333,
    height: 3.62667,
    fill: "url(#pattern12)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 7.96002,
    y: 0.640015,
    width: 4.26667,
    height: 7.14667,
    fill: "url(#pattern13)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4134,
    y: 5.54663,
    width: 1.06667,
    height: 0.853333,
    fill: "url(#pattern14)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7334,
    y: 6.29333,
    width: 1.49333,
    height: 1.49333,
    fill: "url(#pattern15)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_302_701",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 7,
    width: 3,
    height: 4
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6027 9.38666C13.56 9.30133 13.2614 8.81066 12.792 8.06399C12.3227 7.31733 12.1947 7.05066 12.1947 7.05066C12.0027 7.10399 11.8214 7.18933 11.6614 7.27466C11.5014 7.35999 11.3307 7.46666 11.1814 7.59466C11.1814 7.59466 11.3307 7.86133 11.6934 8.65066C12.056 9.45066 12.3014 9.96266 12.3547 10.048C12.3974 10.1333 12.6 10.1653 12.6427 10.272C12.6427 10.272 12.8987 10.272 13.1867 10.1227L13.1974 10.112C13.1974 10.112 13.208 10.112 13.208 10.1013C13.496 9.94133 13.6347 9.72799 13.6347 9.72799C13.56 9.66399 13.6454 9.48266 13.6027 9.38666Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_302_701)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.16,
    y: 7.04004,
    width: 2.56,
    height: 3.30667,
    fill: "url(#pattern16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.824 6.97607L12.8667 7.05074C12.5894 7.08274 12.2054 7.21074 11.768 7.44541C11.3307 7.68007 11.0107 7.94674 10.84 8.14941L10.7974 8.07474C11 7.84007 11.352 7.57341 11.7254 7.37074C12.0987 7.16807 12.5147 7.01874 12.824 6.97607ZM11.832 7.56274C11.4587 7.76541 11.1067 8.03207 10.904 8.26674L10.9467 8.34141C11.1174 8.12807 11.4374 7.87207 11.8747 7.63741C12.312 7.40274 12.696 7.27474 12.9734 7.24274L12.9307 7.16807C12.6107 7.21074 12.2054 7.36007 11.832 7.56274ZM11.9387 7.75474C11.5654 7.95741 11.2134 8.22407 11.0107 8.45874L11.0534 8.53341C11.224 8.32007 11.544 8.06407 11.9814 7.82941C12.4187 7.59474 12.8027 7.46674 13.08 7.43474L13.0374 7.36007C12.7174 7.39207 12.312 7.55207 11.9387 7.75474Z",
    fill: "url(#paint24_linear_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8347 6.99744L12.8774 7.0721C12.6 7.1041 12.216 7.2321 11.7787 7.46677C11.3414 7.70144 11.0214 7.9681 10.8507 8.17077L10.808 8.0961C11.0107 7.86144 11.3627 7.59477 11.736 7.3921C12.1094 7.18944 12.5254 7.0401 12.8347 6.99744ZM11.8427 7.5841C11.4694 7.78677 11.1174 8.05344 10.9147 8.2881L10.9574 8.36277C11.128 8.14944 11.448 7.89344 11.8854 7.65877C12.3227 7.4241 12.7067 7.2961 12.984 7.2641L12.9414 7.18944C12.6214 7.2321 12.216 7.38144 11.8427 7.5841ZM11.9494 7.7761C11.576 7.97877 11.224 8.24544 11.0214 8.4801L11.064 8.55477C11.2347 8.34144 11.5547 8.08544 11.992 7.85077C12.4294 7.6161 12.8134 7.4881 13.0907 7.4561L13.048 7.38144C12.728 7.41344 12.3227 7.57344 11.9494 7.7761Z",
    fill: "url(#paint25_linear_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9414 9.62144C12.568 9.8241 12.152 9.97344 11.8427 10.0161L11.8 9.94144C12.0774 9.90944 12.4614 9.7921 12.8987 9.55744C13.336 9.32277 13.656 9.06677 13.8374 8.8641L13.88 8.93877C13.6667 9.16277 13.3147 9.41877 12.9414 9.62144ZM13.7734 8.7361L13.7307 8.66144C13.5494 8.87477 13.2294 9.13077 12.792 9.35477C12.3547 9.58944 11.96 9.70677 11.6934 9.73877L11.736 9.81344C12.0454 9.77077 12.4614 9.62144 12.8347 9.41877C13.2187 9.23744 13.5707 8.98144 13.7734 8.7361ZM13.6774 8.55477L13.6347 8.4801C13.4534 8.69344 13.1334 8.94944 12.696 9.17344C12.2587 9.4081 11.864 9.52544 11.5974 9.55744L11.64 9.6321C11.9494 9.58944 12.3654 9.4401 12.7387 9.23744C13.112 9.04544 13.464 8.78944 13.6774 8.55477Z",
    fill: "url(#paint26_linear_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9307 9.60007C12.5574 9.80274 12.1414 9.95207 11.832 9.99474L11.7894 9.92007C12.0667 9.88807 12.4507 9.77074 12.888 9.53607C13.3254 9.30141 13.6454 9.04541 13.8267 8.84274L13.8694 8.91741C13.656 9.14141 13.304 9.39741 12.9307 9.60007ZM13.7627 8.71474L13.72 8.64007C13.5387 8.85341 13.2187 9.10941 12.7814 9.33341C12.344 9.56807 11.9494 9.68541 11.6827 9.71741L11.7254 9.79207C12.0347 9.74941 12.4507 9.60007 12.824 9.39741C13.208 9.21607 13.56 8.96007 13.7627 8.71474ZM13.6667 8.53341L13.624 8.45874C13.4427 8.67207 13.1227 8.92807 12.6854 9.15207C12.248 9.38674 11.8534 9.50407 11.5867 9.53607L11.6294 9.61074C11.9387 9.56807 12.3547 9.41874 12.728 9.21607C13.1014 9.02407 13.4534 8.76807 13.6667 8.53341Z",
    fill: "url(#paint27_linear_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.28 8.50135C11.8 7.54135 11.2774 6.82669 11.1174 6.90135C10.9574 6.98669 11.2134 7.82935 11.6934 8.78935C12.1734 9.74935 12.696 10.464 12.856 10.3894C13.016 10.3147 12.76 9.47202 12.28 8.50135Z",
    fill: "url(#paint28_radial_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2267 8.5334C11.7787 7.62673 11.2987 6.94406 11.1707 7.00806C11.0427 7.07206 11.2987 7.8614 11.7467 8.76806C12.1947 9.67473 12.6747 10.3574 12.8027 10.2934C12.9413 10.2294 12.6747 9.44006 12.2267 8.5334Z",
    fill: "url(#paint29_radial_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1547 10.0908C12.728 9.72811 12.2907 9.55744 12.1734 9.69611C12.056 9.83477 12.312 10.2401 12.7387 10.6028C13.1654 10.9654 13.6027 11.1361 13.72 10.9974C13.8374 10.8588 13.5814 10.4534 13.1547 10.0908Z",
    fill: "url(#paint30_radial_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1227 10.1442C12.7174 9.80283 12.312 9.62149 12.216 9.73883C12.12 9.85616 12.376 10.2188 12.7707 10.5602C13.176 10.9015 13.5814 11.0828 13.6774 10.9655C13.7734 10.8482 13.528 10.4748 13.1227 10.1442Z",
    fill: "url(#paint31_radial_302_701)"
  }))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3734,
    y: 12.9066,
    width: 3.41333,
    height: 0.853333,
    fill: "url(#pattern17)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1.13336,
    y: 14.4,
    width: 3.62667,
    height: 1.49333,
    fill: "url(#pattern18)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 0.920013,
    y: 13.0133,
    width: 3.84,
    height: 1.6,
    fill: "url(#pattern19)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1.34668,
    y: 13.2267,
    width: 7.46667,
    height: 1.49333,
    fill: "url(#pattern20)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 6.78668,
    y: 13.4401,
    width: 0.64,
    height: 0.96,
    fill: "url(#pattern21)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 7.53336,
    y: 13.2267,
    width: 1.28,
    height: 1.17333,
    fill: "url(#pattern22)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_302_701",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 12,
    width: 4,
    height: 3
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0747 12.8C10.9787 12.8107 10.4453 12.9067 9.61335 13.056C8.78135 13.2053 8.49335 13.2267 8.49335 13.2267C8.47202 13.4187 8.48268 13.6107 8.50402 13.7813C8.52535 13.952 8.55735 14.144 8.62135 14.3253C8.62135 14.3253 8.90935 14.2827 9.75202 14.24C10.5947 14.1973 11.1387 14.1653 11.2347 14.1547C11.3307 14.144 11.4267 13.9733 11.544 13.9733C11.544 13.9733 11.64 13.7493 11.608 13.44C11.608 13.4293 11.608 13.4293 11.608 13.4187C11.608 13.408 11.608 13.408 11.608 13.3973C11.5653 13.088 11.4267 12.8853 11.4267 12.8853C11.3093 12.9387 11.1707 12.7893 11.0747 12.8Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_302_701)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.38666,
    y: 12.6934,
    width: 3.30667,
    height: 1.70667,
    fill: "url(#pattern23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64265 12.6399L8.72799 12.6293C8.66399 12.8853 8.63199 13.2799 8.69599 13.7493C8.74932 14.2186 8.87732 14.5919 8.99465 14.8266L8.90932 14.8373C8.77065 14.5706 8.66399 14.1653 8.61065 13.7599C8.56799 13.3546 8.57865 12.9279 8.64265 12.6399ZM8.82399 13.7279C8.87732 14.1333 8.98399 14.5386 9.12265 14.8053L9.20799 14.7946C9.07999 14.5599 8.96265 14.1866 8.90932 13.7173C8.85599 13.2479 8.87732 12.8533 8.94132 12.5973L8.85599 12.6079C8.78132 12.9066 8.77065 13.3226 8.82399 13.7279ZM9.02665 13.7066C9.07999 14.1119 9.18665 14.5173 9.32532 14.7839L9.41065 14.7733C9.28265 14.5386 9.16532 14.1653 9.11199 13.6959C9.05865 13.2266 9.07999 12.8319 9.14399 12.5759L9.05865 12.5866C8.98399 12.8853 8.97332 13.3013 9.02665 13.7066Z",
    fill: "url(#paint32_linear_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66398 12.6293L8.74932 12.6186C8.68532 12.8746 8.65332 13.2693 8.71732 13.7386C8.77065 14.2079 8.89865 14.5813 9.01598 14.8159L8.93065 14.8266C8.79198 14.5599 8.68532 14.1546 8.63198 13.7493C8.58932 13.3439 8.59998 12.9279 8.66398 12.6293ZM8.84532 13.7279C8.89865 14.1333 9.00532 14.5386 9.14398 14.8053L9.22932 14.7946C9.10132 14.5599 8.98398 14.1866 8.93065 13.7173C8.87732 13.2479 8.89865 12.8533 8.96265 12.5973L8.87732 12.6079C8.80265 12.9066 8.79198 13.3226 8.84532 13.7279ZM9.04798 13.7066C9.10132 14.1119 9.20798 14.5173 9.34665 14.7839L9.43198 14.7733C9.30398 14.5386 9.18665 14.1653 9.13332 13.6959C9.07998 13.2266 9.10132 12.8319 9.16532 12.5759L9.07998 12.5866C9.00532 12.8746 8.99465 13.3013 9.04798 13.7066Z",
    fill: "url(#paint33_linear_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0533 13.472C11.096 13.8773 11.0853 14.2933 11.0107 14.592L10.9253 14.6027C11 14.3467 11.0213 13.952 10.9787 13.4827C10.9253 13.0133 10.808 12.6293 10.6907 12.4053L10.776 12.3947C10.904 12.6613 11 13.0667 11.0533 13.472ZM10.5627 12.416L10.4773 12.4267C10.6053 12.6613 10.712 13.0347 10.7653 13.504C10.8187 13.9733 10.7867 14.368 10.712 14.624L10.7973 14.6133C10.872 14.3147 10.8827 13.8987 10.84 13.4933C10.7973 13.088 10.7013 12.6827 10.5627 12.416ZM10.3493 12.4373L10.264 12.448C10.392 12.6827 10.4987 13.056 10.552 13.5253C10.6053 13.9947 10.5733 14.3893 10.4987 14.6453L10.584 14.6347C10.6587 14.336 10.6693 13.92 10.6267 13.5147C10.5947 13.1093 10.488 12.704 10.3493 12.4373Z",
    fill: "url(#paint34_linear_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.032 13.472C11.0747 13.8773 11.064 14.2933 10.9893 14.592L10.904 14.6027C10.9787 14.3467 11 13.952 10.9573 13.4827C10.904 13.0133 10.7867 12.6293 10.6693 12.4053L10.7547 12.3947C10.8827 12.6613 10.9787 13.0667 11.032 13.472ZM10.5413 12.416L10.456 12.4267C10.584 12.6613 10.6907 13.0347 10.744 13.504C10.7973 13.9733 10.7653 14.368 10.6907 14.624L10.776 14.6133C10.8507 14.3147 10.8613 13.8987 10.8187 13.4933C10.776 13.088 10.6693 12.6827 10.5413 12.416ZM10.328 12.4373L10.2427 12.448C10.3707 12.6827 10.4773 13.056 10.5307 13.5253C10.584 13.9947 10.552 14.3893 10.4773 14.6453L10.5627 14.6347C10.6373 14.336 10.648 13.92 10.6053 13.5147C10.5733 13.12 10.4667 12.704 10.328 12.4373Z",
    fill: "url(#paint35_linear_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.816 13.664C8.792 13.7493 7.97067 13.9627 7.98133 14.1333C7.992 14.304 8.84533 14.3787 9.86933 14.2933C10.8933 14.208 11.7147 13.9947 11.704 13.824C11.6933 13.6533 10.8507 13.5787 9.816 13.664Z",
    fill: "url(#paint36_radial_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82667 13.728C8.856 13.8133 8.07733 13.9947 8.088 14.1333C8.09867 14.272 8.89867 14.3253 9.86933 14.24C10.84 14.1547 11.6187 13.9733 11.608 13.8347C11.5973 13.696 10.7973 13.6427 9.82667 13.728Z",
    fill: "url(#paint37_radial_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.544 13.44C11.0747 13.696 10.7547 14.0267 10.84 14.176C10.9253 14.3254 11.3733 14.2507 11.8427 13.9947C12.312 13.7387 12.632 13.408 12.5467 13.2587C12.472 13.1094 12.024 13.1947 11.544 13.44Z",
    fill: "url(#paint38_radial_302_701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.576 13.4934C11.128 13.7387 10.8187 14.0267 10.8933 14.1547C10.9573 14.2827 11.3733 14.1867 11.8213 13.9414C12.2693 13.6961 12.5787 13.4081 12.504 13.2801C12.44 13.1627 12.024 13.2587 11.576 13.4934Z",
    fill: "url(#paint39_radial_302_701)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_302_701",
    transform: "scale(0.0357143 0.0434783)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_302_701",
    transform: "scale(0.03125 0.0434783)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_302_701",
    transform: "scale(0.037037 0.0384615)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_302_701",
    transform: "scale(0.0163934 0.0208333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image4_302_701",
    transform: "scale(0.111111 0.1)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern5",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image5_302_701",
    transform: "scale(0.0714286)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern6",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image6_302_701",
    transform: "scale(0.0333333 0.037037)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern7",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image7_302_701",
    transform: "scale(0.00862069 0.025)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern8",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image8_302_701",
    transform: "scale(0.00869565 0.0227273)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern9",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image9_302_701",
    transform: "scale(0.0117647 0.0105263)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern10",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image10_302_701",
    transform: "scale(0.0555556 0.0322581)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern11",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image11_302_701",
    transform: "scale(0.0434783 0.0333333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern12",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image12_302_701",
    transform: "scale(0.05 0.0294118)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern13",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image13_302_701",
    transform: "scale(0.025 0.0149254)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern14",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image14_302_701",
    transform: "scale(0.1 0.125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern15",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image15_302_701",
    transform: "scale(0.0714286)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern16",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image16_302_701",
    transform: "scale(0.0416667 0.0322581)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern17",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image17_302_701",
    transform: "scale(0.03125 0.125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern18",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image18_302_701",
    transform: "scale(0.0294118 0.0714286)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern19",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image19_302_701",
    transform: "scale(0.0277778 0.0666667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern20",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image20_302_701",
    transform: "scale(0.0142857 0.0714286)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern21",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image21_302_701",
    transform: "scale(0.166667 0.111111)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern22",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image22_302_701",
    transform: "scale(0.0833333 0.0909091)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern23",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image23_302_701",
    transform: "scale(0.0322581 0.0625)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_302_701",
    x1: 15.8703,
    y1: 16.5726,
    x2: 27.7199,
    y2: 6.27882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0819755,
    stopColor: "#D50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1378,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3162,
    stopColor: "#FF6464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4838,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6568,
    stopColor: "#C20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#860000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_302_701",
    x1: 8.0463,
    y1: 9.13581,
    x2: 25.7396,
    y2: 19.1452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0691184,
    stopColor: "#B40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4462,
    stopColor: "#D20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7698,
    stopColor: "#E40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_302_701",
    x1: 24.7661,
    y1: 26.0883,
    x2: 15.2439,
    y2: 11.7548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E80000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0528155,
    stopColor: "#E80505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1177,
    stopColor: "#E81414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#E82D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2648,
    stopColor: "#E85050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3443,
    stopColor: "#E97D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4254,
    stopColor: "#E9B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4974,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5895,
    stopColor: "#E9AAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7051,
    stopColor: "#E86262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8014,
    stopColor: "#E82D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8734,
    stopColor: "#E80C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9128,
    stopColor: "#E80000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_302_701",
    x1: 7.89811,
    y1: 9.09393,
    x2: 25.5914,
    y2: 19.1033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0691184,
    stopColor: "#B40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4462,
    stopColor: "#D20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7698,
    stopColor: "#E40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_302_701",
    x1: 8.84224,
    y1: 9.50107,
    x2: 23.4696,
    y2: 17.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00488281,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_302_701",
    x1: 10.0191,
    y1: 10.2551,
    x2: 21.1806,
    y2: 16.5692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00488281,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_302_701",
    x1: 10.4706,
    y1: 10.3829,
    x2: 21.6322,
    y2: 16.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00488281,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_302_701",
    x1: 10.1901,
    y1: 10.3036,
    x2: 21.3517,
    y2: 16.6177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0691184,
    stopColor: "#B40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4462,
    stopColor: "#D20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7698,
    stopColor: "#E40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_302_701",
    x1: 10.1901,
    y1: 10.3036,
    x2: 21.3517,
    y2: 16.6177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0691184,
    stopColor: "#B40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4462,
    stopColor: "#D20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7698,
    stopColor: "#E40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_302_701",
    x1: 10.2921,
    y1: 10.4055,
    x2: 21.4537,
    y2: 16.7195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0691184,
    stopColor: "#B40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4462,
    stopColor: "#D20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7698,
    stopColor: "#E40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_302_701",
    x1: 11.4534,
    y1: 11.0072,
    x2: 19.3387,
    y2: 15.4677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00488281,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_302_701",
    x1: 12.7817,
    y1: 11.7094,
    x2: 16.8167,
    y2: 13.9923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00488281,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_302_701",
    x1: 13.1795,
    y1: 11.822,
    x2: 17.2145,
    y2: 14.1049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00488281,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_302_701",
    x1: 12.8993,
    y1: 11.7427,
    x2: 16.9343,
    y2: 14.0255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0691184,
    stopColor: "#B40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4462,
    stopColor: "#D20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7698,
    stopColor: "#E40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_302_701",
    x1: 12.8993,
    y1: 11.7427,
    x2: 16.9343,
    y2: 14.0255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0691184,
    stopColor: "#B40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4462,
    stopColor: "#D20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7698,
    stopColor: "#E40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_302_701",
    x1: 12.992,
    y1: 11.7689,
    x2: 17.027,
    y2: 14.0518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0691184,
    stopColor: "#B40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4462,
    stopColor: "#D20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7698,
    stopColor: "#E40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_302_701",
    x1: 10.5613,
    y1: 8.42692,
    x2: 9.193,
    y2: 10.2829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#8E6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7486,
    stopColor: "#DBB46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_302_701",
    x1: 10.5802,
    y1: 8.44095,
    x2: 9.21192,
    y2: 10.2969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#8E6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7486,
    stopColor: "#DBB46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_302_701",
    x1: 12.0713,
    y1: 9.55404,
    x2: 10.682,
    y2: 11.3943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#8E6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7486,
    stopColor: "#DBB46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_302_701",
    x1: 12.0525,
    y1: 9.53992,
    x2: 10.6632,
    y2: 11.3802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#8E6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7486,
    stopColor: "#DBB46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6030"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_302_701",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.3969 10.1907) rotate(128.579) scale(0.328182 1.94586)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2535,
    stopColor: "#4E3117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#160E06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_302_701",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.371 10.2107) rotate(128.56) scale(0.267668 1.83805)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3644,
    stopColor: "#4F351B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7246,
    stopColor: "#160F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_302_701",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9659 11.3005) rotate(105.075) scale(0.328088 1.01166)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2535,
    stopColor: "#4E3117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#160E06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_302_701",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9578 11.3313) rotate(105.056) scale(0.267582 0.955597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3644,
    stopColor: "#4F351B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7246,
    stopColor: "#160F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_302_701",
    x1: 12.9021,
    y1: 7.12916,
    x2: 10.878,
    y2: 8.23428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#8E6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7486,
    stopColor: "#DBB46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_302_701",
    x1: 12.9134,
    y1: 7.14982,
    x2: 10.8893,
    y2: 8.25494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#8E6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7486,
    stopColor: "#DBB46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_302_701",
    x1: 13.8016,
    y1: 8.78121,
    x2: 11.765,
    y2: 9.86304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#8E6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7486,
    stopColor: "#DBB46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_302_701",
    x1: 13.7906,
    y1: 8.76041,
    x2: 11.754,
    y2: 9.84224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#8E6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7486,
    stopColor: "#DBB46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6030"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_302_701",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9605 8.63101) rotate(153.555) scale(0.328101 1.94621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2535,
    stopColor: "#4E3117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#160E06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_302_701",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.94 8.66951) rotate(153.517) scale(0.267567 1.83827)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3644,
    stopColor: "#4F351B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7246,
    stopColor: "#160F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_302_701",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.9507 10.3305) rotate(130.042) scale(0.32819 1.01176)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2535,
    stopColor: "#4E3117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#160E06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_302_701",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.9239 10.3589) rotate(130.022) scale(0.267586 0.955693)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3644,
    stopColor: "#4F351B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7246,
    stopColor: "#160F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_302_701",
    x1: 8.80399,
    y1: 12.6183,
    x2: 9.07155,
    y2: 14.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#8E6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7486,
    stopColor: "#DBB46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_302_701",
    x1: 8.82641,
    y1: 12.6156,
    x2: 9.09397,
    y2: 14.8143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#8E6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7486,
    stopColor: "#DBB46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_302_701",
    x1: 10.595,
    y1: 12.4145,
    x2: 10.8375,
    y2: 14.6161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#8E6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7486,
    stopColor: "#DBB46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_302_701",
    x1: 10.5726,
    y1: 12.417,
    x2: 10.8151,
    y2: 14.6185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#8E6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7486,
    stopColor: "#DBB46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6030"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_302_701",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.8151 13.9288) rotate(85.2551) scale(0.315231 1.86922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2535,
    stopColor: "#4E3117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#160E06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_302_701",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.85501 14.0421) rotate(85.2172) scale(0.256983 1.76553)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3644,
    stopColor: "#4F351B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7246,
    stopColor: "#160F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_302_701",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6762 13.684) rotate(61.7419) scale(0.31519 0.971766)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2535,
    stopColor: "#4E3117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#160E06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_302_701",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6665 13.7352) rotate(61.7222) scale(0.257046 0.917975)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E6030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3644,
    stopColor: "#4F351B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7246,
    stopColor: "#160F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_302_701",
    width: 28,
    height: 23,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAXCAYAAAAYyi9XAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAnNJREFUeNq0lb1LsmEYxc9toqVRSVKQ6JIEGbQoDU4NDUJO9R8kiCC0OkmzkzQE4V8RolAOihoOggUiCjoJUQSh+N2X3XldvE80RMPb44EHhFv8ec59rusB/mlzc1Nub29LTFkaBabRaCClhMvlklMHkj4+PkBQktvtnhpUkDudTgetVovhcIjZ2VmYzWbMzMyw46urK6GqQyEE5ubmYDQasbq6ire3N9zf3+Px8RF0tre3p6pbDcH0ej0MBgMWFhYYSp+fn58ZSs53d3dVg37F5fV6JYHJ6Xg8Rr1eR7/f54jpTyi6vLwUqgBJ+/v7ktytra3h4eGBn1arxWVaWlriYtG9FgoF8eeWkpLJpBgMBnx3k5mE0+mEzWbjs6enJy4Vxb6zsyNVcfhdx8fHcmNjA51OB41GA7VaDd1u988R//pln88nHQ4Hj0k+n0e1WkW73YbSbLrrlZUVpFIpoQqQ5PF45MHBAex2OyqVCsXOd0vjQ3drtVrx+vqKdDotVAEqOjk5kRM4tzeRSKDX66HZbH5FPBqNkM1mhWpAJWK/389xnp+f4/b2lu+YZtVkMnHE19fXQjWgEnEgEMD6+jr9OOLxOO7u7vhscXER8/Pzv5bpv+cpFArJw8NDHpWzszNu8svLC0MpZnp+gv55MV9cXEiaVSoT3S2NDrlcXl7+0akqb4KjoyMZDAa5vaenp7z8aU3SZqJFkcvlhKrA724tFgtisRhKpRLe3995TqlMmUxGVRa+vwSKxaIsl8uSVuDW1pacrEiprMPpUCcKh8MEQTQa5ahplKhUUwMqikQi5BY3Nze8maYOVDRZj5JG6FOAAQCl9R7BEGKAYwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_302_701",
    width: 32,
    height: 23,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAXCAYAAABqBU3hAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFJREFUeNq8lttO20AURY+di5MmVBDU8gL8Cy/wAwiQkLgI2n5T24eq4jt47jeUhxYhGu7knvgS+3TviRPRmECA0JFGtsf2nOV99pmxyAPN29rS+vq6yiu29PCA7u//E/Dn0ZF8dxzd9jzrNQAGk/obG+rd3oo9NSW1mxsJokh+HR+L63lyUalIGASypzpxCKuxsqKiKsXFRanha9u1mlQB0kDAeqcjbrcrHfQqQNg+3oGeWAo6l5fSubqSoNGQCMHyliURegs9n06biIToQpXPqvppghC2hSA+vtqHzIognDlj21LIZOR9Pi9ZnOcAUcrlDIyD6y+wykQ9EO3tafnwMHGTPmgxFb4vbcBVXNeowHFzROpeqoY9IEknCmKgxNts1vQZqoBrowR6dgJqGACmIQP3PwTxBvdmHEeKPEd3UilJ2z3+ry+AGMjXWF7W1umphJCbXhiVjhCyX7TbBvo2TgnHU7h+TpkOUsAydEolSUFmy7aT5YIA/XS8gzkzuKYi/XGCfbNtfbYCZuldW9PO+bl4qIguvlLDcGiZVOZLAoy3oBLN2UBvQgEqxOt+G3e9SDxUW1pSr1pFacDlrZYoJk++hdKNIbhQ3SAVrBKOuegh3qUi40AktC7Mz0tudlbyc3MmFRbkTTRMnoUJC6wEHKeRijyOTtxpXKZmnApJAKQPDqziwkLvvFAQGwAGwrKSEAhEH5TQp+GdYlwtrI5sDPIYxEiJuCs2T04kaDbFr9clxL6gkJapuS8lXKor2C/MooW0+XiOKaE/CLoTRdaTANjc1VUNGBwT943JL7+vTA00jYygNUD8AXgXz/ZhKPV9EI+aJNjcNJVhQVJuWlRhUCEj1HBjNfrmbAIo0l4mCHPXnGOVSri7q11UhI/q4G7J/waqEuHrTFqGyzUGofxcrMp4lwsWwQhAlP4e8qSVi74gQLtcNirQH0xHF0EeSk0bgCdI5SV8xJREceAPSWuPD8LgVIBqsFzd6+ueKoQYAcN14xTv/QaM8hmZwI9FuL2t/JEh0N1GvxgPUaWhxYx/Wz/OzoxJ/0vj/8aoe38FGAAB6hhsIIsX+AAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_302_701",
    width: 27,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAaCAYAAABGiCfwAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFJREFUeNq0lstO20AYhf+xHedGghIlpFJKiVqJJ4AH4EFYIFDfqQjYsOFxumBRsUJCUIkkork4NzuenjOyUeQ6TWjDSMMYx5lvzvkvsRIMfXamx8/PMri/FyefF3d7W4q7u2JdXirZ4HDiC+/xUfx+X4LRSALPE8J7R0faymQkV6+L5TiiMP/nAE7yhg4C8YdDEaXM6hQKMm63jVoC5ycnWlmWefat4FeYDsMEVRswVRLMa2XbEoNytZqEp6f6LUBn1QN6Pjcr7SU0nM3EymaN6szWlgTHx9py3bVUWkyOEWLV7nbFT6pLQI3SyUT8wcBMxnX09CTz8dioXAnjn+l0Kn3Y1sVGv3BN6HwZOIYCwANMcMhJpyPew8NKoIF5sGgICEEdbPIC6MD3DTTUKd9nPPE540k7qZCDaunU0pjphc16gGWRBIRUczlzL890R6wcTKXUH9YyYUz2JmKcNsy3vx8e6h+3tzKAqi3UFYGcLmYdRe5gwyLuZ5iJaUqjLGXC5Hd2JFutintzo1JhHOfYhv+4CyCzYpMKVOZwzVGEUsKTO7EsZAGYbzTEub5WqbBFKAH5SAk3NissLCPFC7hPYIZqUlQqfg9Aqiu1WmJdXamldfYVz5+HoRYkQMjTYhpNAPRQY0yYGeLCA5VRb3Yyd5hYUQyVbctflSVV0kpaOEPS0FqjCqAaYsmVMU6qZA+1cZBCsymlvT1RFxfqNfWXDaqcQoWHuhphTjA9nJzgNpJpDgBLZIz7OtFf2XEm6Knsq2u3KwIFm1MlwZw6SqSfqDOWRQUqLCRRlr8MsUKstJPdZS0bl1lrA0B77chGAgsAMYFYKot2uZWK1A8OjJXWW2FUSvsCqGWisNtwHSB52IGeYd9iWc96Pend3a1n4yprmTxDxI2nZodh/NhVG/gdNLmI56YvL/9mY5qtcbGb9kZbsX4oFuUj6i3uOOX9fdnYO8a3KJaMH/spm0ATsE8ERuWw0RcaqoxbGWcOAKprlUqbsXEZlB0mgIXM2j3APpfL7wOLgbSU7Y32fsEL07vBkr8melW72sRgmcSt7LcAAwBz1pck12QJAAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_302_701",
    width: 61,
    height: 48,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image4_302_701",
    width: 9,
    height: 10,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAYAAABmBXS+AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAL9JREFUeNp0kE0KhDAMhV9bRZAKuhQ8kTvP52U8QI+gLgRX4krxB5FoOhScwXlQSpKvL0mBF7VtS89Y/gJVVdF5nvZ2OfEEyrIkrTWiKEKSJEjT1OY9BxhjqK5rTNOEeZ6xriuUUti2DYqB4zjoPpBSwvd9LMtii+M4oigKIRy07zvEHbJb3/fWPc/zzzhd19H9kodlNxqGgdt+bedxGxY7BUGAOI7Bwz8lnBvDWZaB1w/DUODfBzZNQ2+1S4ABAB8mbeguQwK6AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image5_302_701",
    width: 14,
    height: 14,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAW1JREFUeNqEksuKwkAQRW/H1qhEBUVFBQOu/ROXfp6f4E+4dyG4E0FwEVDw/VbUntzCOBLiTEHR1Y9Tt6poIGTdbtdMJhMzGo0M/jD1uel0OkZrDdd1UavV8Hw+8Xg80Gw2VRi0gqDf7xvbtnG/3zGdTjEcDjGfz5FOpzEYDMxXRZa3XC4xHo9xOp2glBKoUqmgXq+/gUajod7g8XiUjFRYrVbv9XK5CJzL5VAqlSSmE9Z+dpNKpXA+n1Eul39L8RVZAdVvt5vcV6tVAXu9ntF8xEPCHAQzJ5NJccdxBN5ut9hsNpJkNpuhUChAMygWiwInEgkBaLFYTJxT5krwer1KC+12W6lgMPl8XsB4PA7LsmS6+/0eu90O6/Va9ovFAq1WSxgdTIpwNpuVHqjCBNxTjVWwTJ5FfoDXZE0mkxGAD9k32+Cw/HP1FaR5nmdYdpCA7pevIn/Op/nfTVHlcDhIb2HoX2PfVI+6+xFgAKxyvL/t3AhFAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image6_302_701",
    width: 30,
    height: 27,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAbCAYAAABr/T8RAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABLZJREFUeNq0VltMm2UYfv7+PQCl51JKoUWOQukGKKQwJmzJnBcmMya78DBPWXZhnGaHuAuNCdxovDB65zTOzQujFxqndzORZct0ysIgIriW88rGcIPSE+3f/u3n939SoOFgId17+f3vn+d7n+d53/cDNone8ydJaOI7gocU8o0O3zlUS7xDI9CbjPB7viGiKKKo4SUul8DcRqDsA8ehtMKBukYXWrs6sLjgh73lGPdQgD99o534fPMZCar8PBSXluDpFw4jmRAhJhKo7nyLyxnwuZN7STyeRCCwhHhcRCyWWElSKBUocZShdpeTVT89OgHXU2e4nGmsVPIwmzXw+yNIJlNIJJLsPBFP4PbYJCKhMB7c+wfOxxqRNp6m8jC344q/fe8giYSX/jtZ9nGcgt6/H4QgiCBk1dw8zzPtWzv3QDKdSOnveP4DbkfAVz4/QiY8PqRSKQq8CiKBh8MxRn8qtXouk8mg1hTCai9l9AuxGJo73DDUPpf1BbihH44TvUmLpJjE1Us3kBDiGQkipTwYjLILpKlPR75aTY1nRYrmvPjmMSaFtfHVrMBlU6MzWJwPQq5QoqnNBbW2MNMEvAw6XQFMJg00mjxKtWzlWzQSwZR3HHN3Z/Hrz5fZ2Z3+L8j0H2dJVlRLjnY9XgdbuY3SJuKubw6jf3rWJUep06XKl5biVN/khm2Xdv7s7RnU7jvBZdXHvWePkNpddZDJlfAOeSkLcngG/sr4QZJ6cTHCLsAcv4Z+qe0MZhMc1ZVwtTSxFtzM+esOej97hdirHoHBYqEtNE0rH0Z4MZCRQ5YBJfCNtJeqlyZeffNu6h2Rub/12W5uS2Apvjqzn7Q9uQ8mq5XqH6C0+eC9ObAuL74FOC/nodHp0NLZzqhPR7r6TTU4d2Iv2b3HjQpnA2JRAb6xMXj6+1kFayMhpqjmAiIRAdFoZkesbbsaVz3igoAUZDjw2kfclta/8PZ+Uul0osHtZu3tGRiglcgx/Pv1DatfWAgz8LU9n144knySRqVVVXB3tSGrnrt64Tgpr6uHxmCAb3QUnpv9CC0sbIv6dFjsdhw9/Tr4bIDPX+zraTJEu4vLHCirrobebKaDRkDI78/Ulfa4UqWASiVnVUqTcG31IXohuYzA5rBnByzFxd+metrsfLfZVgKdyQRjMZ1YKRFBuqeJNGrTulJAXi5bHjQcWzZp8ACdgOoCFSw2K7Y93L883UW6njkEfZGFjsokvIODzEQjfX3rcgW6XsNhAZKTbnlnYdSroVDwjA1+u8A/Xp/uaaeVUywYaa8X2WyIBP0I0V6Px4R14zY/X8mMWahWsepXZNnJLv3+yliP28Z1z834UExbpYjSr9XroMpTwf9gPmPDSZRKa1W6gKS59Nh4/ycvJ9/pC+LoJ9eYTJdNBuKoqYLOqKM0UkMlE5i8Nc5kkDiWKK4oN9NHhpwuGzUMhkJsOUC2pfupTtJ2oAM6gxZiPEY31gRCgTCGBieh0+Yxl69c+ONrXM6Apfj63YPE2fwojGYtdXkSN/rvwWwxgicJTP09Qp9PwgpoToHZmD31BCnUFIDkmVFTXwODyYA7E+OYHBnGyx/+klOs/7lI56YPgn8FGADT/CCrvSAQewAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image7_302_701",
    width: 116,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHQAAAAoCAYAAAAv1t6rAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABKFJREFUeNrs2udu20AQhVHScq9y7xb8zw+Xx8kTuvfee74BLsEEkkw6lEyuhgCxbLGMHN/ZQsVRavv4+PidPo/j+FfkW6W2uBVm04cdOCxQxw0Y1IFLDPq/mA7cA6COGzCoAwcO6sAd/L/sBuafzxCc44YCKlSd12o1T2+Zpy1fgb69vVlLSt/f3+16X19f0urYgQsCbYJQGDCYIAJK+/r6muCqFJNY2v7+fruWJcGOmwO0KGAhCpT9+fk5enl5sWu06T4WUNI6PDxs14aGhhJkBy4Q9Lu4QtROOkFU+/j4aLtgQQYURFLKPj4+Hg0ODkYDAwMO3AnQ7wALVKlUam9ubqL7+/vo4eHB7nMucA2eBDk6OmqwY2Nj0cjIiEGzcc1xCwTNAyxUldnb21vDAxVMYEns9fW1Xef86enJnieZlGJg1YI7Pz+fYAPfy+mNO/0BX6VXiaVfBZVjMIEG8eTkxK5fXl4mJZqWskxyp6amDHV6ejpaWFgw6NnZWRuIca3XgONuf2Ar4HRywby7u7PradCzszNL69HRkaVX6JRlIBlUzc3NGTItyWVbWVkxZO6HXp7jn/4FmgGrHJMyYAEFD1SOT09Prd3f37cyzTN6ltSCNjExYUkGc2Njw64vLy/bOX8A9Xo9SOC4TL9Mu/KsgRJoFxcXBnp+fm4J5pySfXh4+Fe6STMlF0BSC6ZgQaZPpkwLOITyHJf5r61dedY0h9RSqvf29mzn/Pj42OBIMOia+yqRMzMzCSatUgzs4uKilWfNgauGG0cV2loBa5RMMoE7ODgwqO3tbYPnHFzK8tXVVQIMGIMr0ilMJRdkdgZc9M/czzL//WngSoFmwSWtSiODKLBJrGBB1jWeJdHNgNXXrq6uGvLk5KTNe5n/0j+XdXGjsqB5gMEkneAJU7BKLiNnAdP3quRSnjU1Anp9fd3OwaVkc11TqDLgBgOaF5j0ClKwatn/TS9pJZlaoSK5zHM5XltbM2z6Z7D5Nz81eg4WNOvomTQqvQKmZYBFioFl9EwfzaIG6GyUXBLMXBdMkkp6wQR4aWnJjgXdrfLcE6B5Rs+kUcAMoBhoAcsxO9MiVrLAZQ4MMCUXUNLKAIr+l59F3wsuG8Dgdnr03JOgeYEpz+Cxgwk2x5om8QzQ6fe+rC2zWsUx5RlQUk2KGU0zaKN/LhrYQXOWZ14WaIqkxO7u7trqFall3ksfzT1Nqeh3gWV+Cyb9scozKVaZ5n6WwVU7YAf9JjBpBAtkVqtIHInlGFiQuUb/y6Yks1GWGVBxn1Ur+mEGU5ubmzY9IrlKbd65r4MWCExyQQKVMg3gzs6O3QdYUyOWKtkEDCA7mFtbW4bMMeiU7qyLGg7a4akRCU4vboDNAIskU2ZZ6GCjX6bUktxGo2GJBZPEMlXSC319z6rd12EdtEvAlGGtXmmgpfRqDsxzJFGv/kgnfS3YJJiWn9EKlNLroF0G1qtB+l4Bk17AGXCx6f0u81dWo/Q6ENB2X3d10BKNnsFlZKxlSs4B1HeqtMTooBUsz0oxuCqvWcqt96EVKc8gC9NBAyvPX81FHTQQYAcNCDi9UvQpwADB+UGHDZKjngAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image8_302_701",
    width: 115,
    height: 44,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHMAAAAsCAYAAABWm4fEAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABQ1JREFUeNrsm+dOG0EUhcdgeu8dBEI8XR4nzwZCSPTeey/hu8pBG8vYC1nsXfuONJrZkvzwp3POnZklF7xlqr29vf0uvJfL5X4x5v3nySbAYs1hZhiew6wxgP/Yrf+M6Qb48vISGhoayMXSIN9z05WZMoDPz88GjvH9XQPJmM+XR+Uwqwjw4eEhtLS0hMfHRwN2c3NjczpAAdnb2/sBsrGxsaRC3WarZJ+APDk5MThHR0fh4OAgNDU1GVTudXd3h9bWVoM5ODhoYMvBdGVWGODp6anBe3p6ChsbG2Fvb89Aocrm5ubw+voaJiYmQmdnp80ByL9ra2tzm60mQCDQzs/Pw/b2tqmOEYgAxU4vLy8tH9vb28PU1FQYGRkxqHSAAhObBbjDrDBAAF1dXVkViurW1tZMYbu7uwYSsDy7v783WwXS6OhoGBgYsD4+Ph76+vps3tXVZZmq90pVsp6ZCdknlkn+AY1xc3PT4HF/Z2cnHB4emipRKooj9wA2PDxsoObm5uyaTlaSkbynJUlhTgqeF0AJ5t/19bWBQ2nHx8dhZWXF5gDFRu/u7gwiwICEZaK86elpAzQ2NmbQlJHMUWIp9fmmQUL2CRhAUXkCDZBcr66u2jX2CmAaALFKoKFAwHFvZmbGclHPqVjL2afvACUAUIoTqOXlZStWgCigVKfYKUUK4Mi5oaEhu8Y+sUpASo1YKeorZp/fAVi3MOPap4oUcg+Ii4uLBoz51taWZWM0/zo6OkxxgAPk/Py8WSrZ19/fb3Oq1aTh1R3MryzgqTBRmgoYVMjIfQBjs4IEuJ6enrCwsGD3yD1G4KFEnn9WhSYJsOZhlgOIslSBUmnKOukULWdnZwZVOYktAk4FDB0bxTKlQgoYqY/rSgGsSZhxFvBYJwpDbYDa3983gAIKQN6TooA4Oztr4ASQ7KOgYY69UqX+hVUVgDUBsxw8gFEtssOCCrkGnKxTNspzAMoWsUm2zlAd4FSFojyuUR1ZWQxgpeFlGmac/ENx2CeLdZqUR+4BEPVhnbyH8lAY6pLaAIZdkouokaUDClSxU231ZRpmOYCojgwk57SBzbi0tGTVJ71U/nHNug+IzFEzJxU8/58FvMP8wgKe7KORe8BDeeyDsmjnGQApZlCbqkxGwLEXitIAyFIiusBnnnYFphpm3P1PQKHCi4uLjy0zWef6+rq9B0Cd+5F7LOLpgBNEFMk7KFDw0pZ/mYIZByAFigBSqAARgFgqJxJkIfBQJQ14vEuxQp+cnDRLpQOQEaVmIf9SDzPO9hkNOFo6CCTbatgn9/ScDAQa0AHFLgz3gEhBo50XqtNaBVhRmHEW8MpBrJQT99vbW1OhNq4ByagqlGWEDm+Bxv8BTKwU5UUX8LUO8Edhxv18EDCCyDoPgFgmXYt3Waw+cNIJPFUmeaf8Ay65WEv5952WrxRAoACQDkxUCEB+eBQokNznOcC0fECZKC2660IX4HpS348oM+4X2AKojsqARc4BjxGAKBHggq5jItRG5gkm8HTc5AD/A+Z3PqEHTFSVzIEIDEEFpt7lvqABkh2Yzz6fcIBfgJnE3z8oI1XoRIsYQWbkmq6Tdx0d1Wv+JQIzKYCFeUkHjDIzekwk1bn6EoD5EwCL5aZgFirOASYE86dBRoHG+UsmR5JyZTq8DK0zHWAdwXSAFa5mk7ZaB5hhZTq8jMN0gCneNIhjtQ4w48p0gBmG6fCy2f4IMABs9/8yEySxAwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image9_302_701",
    width: 85,
    height: 95,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image10_302_701",
    width: 18,
    height: 31,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAfCAYAAADqUJ2JAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmhJREFUeNqslT1L8mEUxs/919K0UkEh8GVoECIiXVREIvMlQdob3Jv8Dn0Bp5aWoNp0EBchcHAyF1uc+wCBb/mCWKb303XAcHjg8bbngr+gwo9zXefySLSkg4MD6fP5JK0hsQDwGyFoc3OTzGYz1Wo1oQLSANHpdGQ0GklKSXq9nmGq0gwGA21vb5PJZGLYbDbjJ5lMKlnUtra2GAKYzWajyWRCHx8f6hPV63UBGEAWi4Whg8GAWq0WJRKJlafS8FIul8XGxgZb83q9P18iOyUQNJ/PyW63sy1sDRan0ylFo1GpBCoUCkLTNHI6nbS7u8ufdbtdwjKUQND7+zu5XC7a29sj5Pb19UXj8ZgikYhUAj08PAhYPDw85A0CNBwOeRFKIOj19ZX29/fJ4/Fw+Mip3+9TMBiUSqC7uzvRbrcpFotx+CgngseEqVRKrgyCXl5eGOL3+zl4bLLT6ahZg+7v7wU2Fo/HyWq18meY7O3tjc7Pz+XKIOjx8ZF2dnbo7OyMp4I9XAc8SqCnpyfRaDTwM+Hglbe2rGw2K1ABTIXfIab6/Pyk09NTqQSCKpUKBQIBcrvdbKvX63Et/noh/6VSqSTR8JubG24/NoriLl9RbRXQ7e0tHR0d0fHxMU81Go14EUrWFsE/Pz/T5eUl1wFZYbLlgmqr3purqyuBo3dxccEXAdZw/JRBUC6X45I6HA62By0KqgTK5/MC7U6n0z9T/UrNZlNWq1WJv7KTkxP1iRYqFov8B4GbjuDD4bBcC3R9fS1w8FBSNB0nWlvXXiaTEdggrgKgv9Z38PL7NEv6HwqFQvKPAAMAFEQBivph/2cAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image11_302_701",
    width: 23,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAeCAYAAADHJYVoAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAzxJREFUeNqsVsluE0EQfb3M6g0nsUkOLJ/AX3BBSoSE+ADgzkfwAZxZJDgiDhxA4saJIxIHBIcckAgiSggicbzPeKapai9xxna8iLY8HvdoXr1+r6q6BWjcfFE3xgBaCeQ8B2nSg5JAMR/yYzy7JQRWGJIvf047iHoJeolBrRXRjKH7BLvf9xDHMe6/49DLD3HvbWo+fNkHv66kAFNk5nGnCRnVkXYbiLstHB4ewLx5sNQKNF+qpQCHJ20k6YCgUMQ8Reu0jm6zhh6BmzRdXhamctzoTi5JSITlTXi5Ehw/xxPAzhOznOaCTdTIrld7wVkgqaAcbzVDeSiZgRf9R8oNLHOpHEjtAtuLs7cIgacnHyhFYARIrPv/tZUKS1gqOYeZte8SWCadNbMO8nDDkgVXFEwtwV72XaUUtN+sqyyLT8mjKEARmuVhcLGELJ6jIKe8wDJw0HPSSMk1tjj4ZjlAhXK9EDjQmSjMlLPF8fPW1JHuO0/NQuCa2LDm01bLzDlbWPthinrkwSL0+5oT2yieXYGcNUNgpb0RrLj93MwF54zhQuKUdGfor/3QymLoIwcGmzRZrIjWiz7yvgNPy4mUtMVE2msvRFDcsPqPxgUt4Vz1VChATA2L+1ejE581ssFg7eMOzVEL5WDWbCKSzGPO0jjEmjcMlmWaucpxLbA1l0A19Zsk7s5kf465pu1no0BFM4Cut2P0suwJuBe1LXNmzb2f/1/IfGQs6e6TqRflvV9ct9Vq18dFRkZPawkyO8EBqpcCa+607GG2yvHh0gq4uDhrrFxiDvPxAGsFzwZYp9/QcyYKS7sh/EJ5rIs6E9rLWWnEAa5W8ghcDYdMzsrj5oq2W1p/bEugO6WxEPgwwNZaSOypBgb6j8fgAEG52m/D3BAyRSXn9YeX20pcv1ywmzgbPF5gw302t7ZFMvn9xjbWEvQirXN4KOLzy95RA0e1No6bUZ8dmRqUNtA8PgCizrmGttJJ6u7ryOz+OrEHqGEZtGtH+Lv3jY4hbdt/QGccuQr4qzuu+PywKq5XC6ONPShVkK9cwfh2thLz7Ljx+Lc5Gci0//Ujotbp/wMfH9ce/TQ/Pr239/8EGADBvObpEueaAwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image12_302_701",
    width: 20,
    height: 34,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFJREFUeNqsVk1v00AQHW8c9VPthV6QuHLhxP+gAokDNy5F8CP4E5yRKnHggIQQIPgBXDhyQ6hSASGKmjQuceKP9Xq962VmbUe2kzZ16UiRY2v18ua9N+M40KpHH435duTDzevb8OJuz4GOxdpgdPWmwt7ffjYy1bNLAVL99iJ7/fR1AGGSwZfvHuy+5KYzIDEhMG+aQKZz+0zlxoL+OY3g/itxIVCnAvODCIJEw+Ewah7AE5urfXCZAzvba3BjZwP27zBnKUPvdAwDzweT540DpGAsFGhkS+x/DkN4+FadyZYRu5ORB8cnHhz9+gGSB5CrrHEoR9Q4VXgt7gc+h70P+UJQZkoTp5OpvWZJBJmIIde6cZAYRiIDP0pnzxaBuvu7zLn19LPh4Ri0YUAn+muboDMBrLcxD4omOVZbBzZW3cUaHhwcAI9CcFjPiqaksG3b1lscqH1yfoR6krYPXkszB6jf7DkmV5aVkgmkkQ9apbZ100KkJjWCUrSk0o2BsC03DmuFGoYIXOi0tnXNsmRu37ZYr1RqGKOe/R7DWLkLJuXdY0el3ILaUON3axKxLJ/Vo1TnHaAElUHN0UNQYketU/HJsGCe6znxKR0cNTwNBExjOeuALcqSwR+r2k78IWg0SbcMys0Fl0PBUtiJERglMiWNp6BENMeUZj1BLcn1SZyezZBAJS+CLkLfglGUKAHtUui2kAoCnp0DWG6FyiDSq8ilnJt1yqVE0DTTNj5nA84MSrHlCRBjmnPKaDuXVVE23WX7LdcZstLgrqwDzicwnCadbUKvvzI7I1DHgMslLZcsTWmEwjwWjCUyDcG03gx0NxjzJYAlKLHU5UrLyG2tZrFaHptzisaSolMloL6FnE6AZTYtKLarBAeOgTe1XFIeuzGkWS9zaExuZ1zXNjvlcWu9361l2goasyiT0Jokgr/Nbc1YR8D3T6xBKk2sKaRp5Tbl0e11BayPHALSrNfH0cV/Lt0BUctq7ZCWycSbjSD9F7ocQ8omaklvyHh8fPkcLmwdNzs5/v+ANJbYMpkzOT6Eq6t7z439XFXL7fonwAA+U2KTP/jVXAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image13_302_701",
    width: 40,
    height: 67,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image14_302_701",
    width: 10,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAICAYAAADA+m62AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALFJREFUeNp0kDsKhTAQRW+M2kjAwk5wIy7ZdVi4BIOmi4VYisEPji8Dgq9Iqgw3c+ZMgMBpmoaMMfTW8Tccx5H6voe1lut939G2LdV1LaL30Xme3J0kCaSUWNcVWmvOPFn6y7Zt5MPrupCmKZOO48B93yjLEvM8I/Lj2CGOoZRCVVXIsoxJnjoMw7+bc45+RFqWxXtS13X09edlhBAgInbL8xxFUYjQb2CaJqaG8keAAQANTGEU+FCHuAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image15_302_701",
    width: 14,
    height: 14,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAWFJREFUeNp8kkmOwkAMRX8lTEEgQhCCNUhcgAuwzl05CjuWhEVYRBEIEGEQU9z51Uo1Y1sqqQbbz98uhQ82Ho9lvV7DdV0Mh0PcbjcMBgP16GM9Hjabjcznc6lUKvosIgjDEIVC4S25CcycpFQq/V5aFsrlMg6HA5bLJc7nM6bTqbwFHo9Hc9npdNBut9FqtXSJXHEco1qtPhODIJDVaoXT6aQpNM/z9J4lZ0k1dbfbYTKZGIDV7/cVs9Js2zZlsjGkKqWw3++x3W7RbDbBHtDXqL5cLqBGrkajoXVRY7FY1HtSHcfB/X7/09jr9RTbz2AS2cVarWa08kxqFEU6iNSncfDxer1qCptBjSyPmimH5ZLIEZlAUtM01Q6ksuRcZ66bSWezGUajkXqaLDvIjHkgm1Wv19HtdvWd7/sK32yxWEg2Gv4HyQiSJIl88nv7SyRSK41aM+J3yqvls/rPfgQYADYtvQHr66igAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image16_302_701",
    width: 24,
    height: 31,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAfCAYAAAD9cg1AAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABFVJREFUeNqcVk1MY1UU/t7r6x/l8TdhYAChQAEZGfzBhZMYY1y50cTEuNBETGZ0NRt3aoxLjbpwVuPKjYnGxSQmJrowohkGmZGZkd8BWmhpKS2FQl/b15b+X++9hbaPv7aepL23972cr9853zn3CDjHPnl9kHTbevHOjff5b7nvTQE1mnTa4dfjzxJFifN9LBqDff4xhp5+Cv/HNP/ouw9fJOwoFIrhCIAZY/HWB+8hk06jbXS8JhYi+5r54TopOC+YxWKEXq8rvrTj28bcvRnU1VtqZiAu/nyDNLY0lB0RGA0S6utNxZPUQRKOxWVEQgo2pm+RmhkYjHpcfWWM+S58qDGAchbbm1t4ePce36uu21WDiMHAPnzuAOJqUvPAQJ2Xs8ikM3CtOHgeNtdd1TPYcHjR2NKI9ifaYB3q0Tw8zkLZC2F2eqYmFuK1b6YEZS8CQgT02Hog6koORVHgIGxllstm4VlzcjYrc4vV52BtyQk1mkCdLKPD2lUqEp3IAerqjMWzqBLB/T8n+f7vnz4mVQFcuzkl7Ph2IYh69F0eRH1TSVU6CsLCxFZm+Xyey3bpwWxVoRKPNlvOTUQUFQ0tF6je5RLAYZhYbZTL1ufe5KGqigGzd7/6Swh4/dBJethGRygbsRQqSQdZNvH1yA7iCdz59XdkMxnsLn5PKgIwcy6tQA2raO3oxPDzY6WXaI4FgTExnnDAVGW21KEqAJYL7/oG9SbShDdAlEq90ECrW5bNGtkeVXg0HIH7/rekIgBX1Pw8UskUOnr7YB0ePtEVy4vvqE89mjy7wk8AMBZb605Iej0Gn3kOOroer+7jLJwrdp5wr8tdmQEz/4YLSjAIS4OMptZWbX8XCqpia7HCg/uYO6zwhd++IBUB3vjotqAqCg/MlReuahSllwrFJ0mlsyytcLfDiYDXh94nBzShEs/K/tzUXYSDO2hpv4Qum01L+1gLYRZRwvB7vDzpjx/NoSLA+JcTQjIe504uWa0aRZVaiKF4ls/l4HW6sXiswsXzqvDfyUlE94No7+7GwOio5lmhhUjFFlK4v1X4Njw84Q/uTKMiwIGqIpmI04QSGExGjaJOayGEEJ6P5dmFIotzAZhkfc41Sj+Lrv5eemd0akeSU1oIk62HJjydzlZmUGgfq1B2/DCZjegfGaYspHNbSC6XhxpLwm23I0zv8IoAjMW2x4NUQqXtQkdvvybt1XrYQpqbLdij404snoJsMWHwymU0tTRXBiiwcFAW2zCbJfQOWTW3HhOqfS0AJZzABQrS2GCmihPhWFjmk2DVQ9TErbfJwIiNJjKP+X+WENpV4KCOc3mCgf6LPDR+v4JMJsff//wXh3Dm6Hiaude8CO9HIBiMWF0NolE2oquzmUuV/c08BTKbDRTgoOj8xOhYyX787DUy9vJL9FKSQKjDhxN/IBGLlrkiYEPEmbNp1UCfvkqaL7bRy0lBNBTC9ZtTZ/r5T4ABAObV0aurG6xsAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image17_302_701",
    width: 32,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAICAYAAACYhf2vAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAWhJREFUeNqskkuOgkAQhqsF5eEzQpSEuDTRncdw6Tk5gXsvQNywhLCAuGGhRlFBJn9lmuhMopmJJEVVqrvq+7urBX3oWy6XVVmW9GhFUdRxv9+ny+VCeZ7z/vv9Tr7vC/GuqYyPxyMXoRm8jEej0VP+57r04hslPcRwfrFYVI1Ggxd0Xafb7UbX65Vs264bSYN6FKG4qio2RVHq+BHQbDY5brfb7FutFttgMCDXdUlVVYqiiFQ0MwyDi06nE3uAdrvdL/UQCiCKTdOsbwoQAHu9Hg2HQ5rNZgybTqecRw7jiOOYVqvV062L+XxeASCbSwMExZqmkbwhgNBsPB6T4zicn0wmDO52u7z/fD7Tfr+nIAhos9mQ53kvx6zihxuwLKuGYBQ4AXKAdTodNsAhDKKyLGOhaZrSdrtl2Hq9Fn99vCwATTFDeVI0BgRvIQxDHgXeRpIk/4K8FAAw3sHhcOCTfxrw7vsSYABOYtlTmpkhCgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image18_302_701",
    width: 34,
    height: 14,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAOCAYAAABKKc6PAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmRJREFUeNrMVL2LE0EU/73Z3dl8bHIaz0SUE1stBFsL+2sOtbMTtLT2/7BUFGy0uEZstBSsJaWIoODHwRly5pLzzOVrxzcz+zFrAsbzCgeGWWb2ze/jvXnAfzDuX4PyDxv84DrUMv9VAoCIJ3/HHKF4esJ+74/z/8gN2n68oTqdDtrtNuLpGAEH+B6wN1oMooNTELPyFM5emUmMZzCMBdmpEvp6qUpg7ZjApXsxZY6ol7dV7/sOJsOB+eFEze5/+wGslOzFrciC9IZJDN8mRK6mUQF2h1axR7nyWWxJSEZr1QTqJcKpGvFdaWSMQmoCVo+DHhpyjEjavahRdOFgagFDD1luNKFUdTOyq8ZYrQpMY70nzHlF6jMqunp3QllqtBu7W+8w2P6A4WAHjdI0U9ndj/mbMrvhpEI4KSkFZNSHPhk3hHGETHroN3BbPE3Qna3sIHMkCmIurD7GtRmk9jQZ+mIkgOmQHmV5zvcclYuA0yGY2eoF0M03hZ987YZlNGEJfGEoCnHSp6N5o5pAmfN85jLo6ubcpT66b9nX41yBH7lmJkfbIDS4HppA/Sw7cR60/mihMh8r54Avr/mdDf4RlZwCYmvDOq/Czj+QyIv1yRWF2hrw/ll+omb5k5irCKcFCefhueDlk5xqdqR5kQk8pGVkWJgXt5SpyE+v+OEnHWw6soT0lNxYRn1HebLKqvMSWuxxyJV/mklI0MZT+hs/54baXFdGTf8zK2abdd/T68+uJeXphiCtYi9pOBV2IOAGE1SXcmApIgVSz28oQ0KnQOd+7yuDh1a5l0x25zDg7vglwAD2w5xDAb4/TQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image19_302_701",
    width: 36,
    height: 15,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAPCAYAAACMa21tAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAnNJREFUeNrEVU1v00AQfes4DUEtICIkkBAS3PgH3AEhQBzggrghUcEfQBz4CfwDpMIVpPIlJNqeOHIjBzjQA0IR/YAWlahxnNhee5eZHcdN1K+0ATHKeuPZ3Tdv582uFfZhdnbSQneA8sEBv7o8pTCiDQVg39228HwgaQOlMaD5FUhjIIuAyuHByUfOEKpHrQR4pT0T3XGifXPTIqVMhKsFOFrfpc80kStvv3jipBDrWe0s1JUnat+E7ItrFq0FCkyZiNcF3FogauYTDD8kE7tZuQr41A6d2pXYpgH7/IJFsETyBCKLDiUwTzV6tALxyiIxZ/v0pS2JFQ47c8dC0eu3OSJDJNJuPpDhn5gncqv7HbWJkH17i4qWinV+WryjZoIhSF5PDVfL6oEuJio7S5lpvAeCxeGOPAViAY0RIQ09Unr4nnIl1o6N8+lMxtlntmgZrT82rlCidfRDlRJ24GGqfGg6uuMn4I41nyBXrIOWGSGhU1ZVAFqRcb5OYh14V1vn52BhwiTzluUEchJxClcZUSpj2sg4E398HVYke3beoloDlj4Q2orLAoPxJA4aREIypOBJJsRcn2eBrauFAAfVOQnumQgTDRLJaprvt+Jv4PPcyZdSPqr/9k1/fUGy1kDY/FGk+ncoEvCOetaONzIQ5/6ePO1kUKaJCt2jXZGkR/Duq+2vG7//RY/VoI7XsNCYgcnSArQXYK0jJBiYew7WL0eWpyvOZM2911AjfTqi6Rt29eeyA5//XEcnSnCU7rPF1uCui/99ADvteqRv2crURdtcD1wWPtbrMGmCcklq5G8G3pMtP71qPz06Z/Ef7I8AAwDppXM/JXV1hgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image20_302_701",
    width: 70,
    height: 14,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAOCAYAAACSJWqFAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4lJREFUeNrsVlluE0EQrV5mn9iOs4JALIEP+OeHA3EBbsABciVuESQQQoACURyIt7E9O1VdPV4i5wORCAi0ValeJLvfUtUR8H/Am5dQT3KeBxrg6SEI/a8RcNnZcAbgayaGhr6pBJQVQFWvxigFaPan6JDBbHE2KwBiFyB0bwAxlzngeADQDRk8RVYCTDIkxRJSExnAJNGgddcHkDhP0r+ImGUHELjKzr8lvG7Ozqecx0jCyYj3i9oSYbNL6AWAIvA430CHSMHhORh/YimtcwCp3yjfqF9b8OvUp+Eh4LRgsAQwQMBK8lphtLwFGRTt2HDFf+wNxO90gIl6NVc29xIGTfckMijIKbW9uxZ8eQIaIXAhuBQo70ZYOkiag7ZwcNPRvO9bd7ieMmv6BjcIcS5gY+8hjHqfIZ1mkE2G1+sYIuBiAySwvfGCCAJA+9QI6Swv56IZ2zfKxZqtT0CpSRIhUnKOAwYsbPj2adGuB1JrzAheEhkS3LANQmnwNvbNHi4wSzxT4LXvwvnxO0iTKyKmKYHT8QL8rdZqCRDwouKgF6C2xGgLvuVaYKj+drjqAFLc1ZwVMuG4aq60395j0DYkggy6B5DP+qC0j8RQYO0IaYgBE8K4pS4LvHg978BKuqhk9fM9hghIsgX4Jn+bcKZxhiUwxs7+4dye4++4auGAGIHv+EwGPY2hx3PH4ez5qFzIoOOd+wZsMUtA+5EBSeB0uIVzFyMwIOmDC/MbVcmNx2tFmPiCJe7VNe+XeYapwnuVMO2f2DmvtRdBmU1BKrW+xyyXQH0x4/nXIRNA3BLBylq406iO+8+f3YO3Rx8h8khlbn4EmgB7UQRh5/aS0mjxeG+uqg42GbB05moSgCaXRWrnBDQ1oGaD0wXIupwrT+dVVRh3VBhFOjHkmSgK81/uOg7M5usXUFMZ5GjxDbzL432ALwMGn9j3n9TGngUhCrMZWKtTffs8j2JllCO1G6Xp6ym78S5IJzAKGzujuhdtnM/GDBY/494nJsKAZIBVkUFOoDAzKMxFbuLJ4dU/IuII3UEkUA+gmvfwJ0KHbW6etoi7uJQEOsLm1cHG1TWNal7XZHHlLVkZ+8joDJTj4cVTo8x0eGbm+XS0sPKgZwi6DmC/OujVgzsdAQ98H8L2NgStLYh2HplD5Ua2dmujTJb0UcQSku/HMBm/hwnVKK4PXvUF3LDxQ4ABAEdBFQD7pI5LAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image21_302_701",
    width: 6,
    height: 9,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAJCAYAAAARml2dAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJdJREFUeNo8TjsOhTAMcyFIFaJig52x979GL9CBgRPQqgIGII+E954lKx9bTgy+iDHyvu9wzmGaJkPzPPN93xAKlmXRSiEEbc7zxHEcvwDQuq7aWGvBzGia5hXGcQQRYRgGlFLQdd0reO9RVRXEIMfbtlXBbNvGxph/hLqJns2D67r4oT5Q17XMIBFyzhoj7PseKSV8BBgADddFZq50goYAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image22_302_701",
    width: 12,
    height: 11,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAALCAYAAABLcGxfAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAANRJREFUeNp8UUsKhTAMTLWiC12KBxA8hof3HnoCQVz4/8Q3kRTfhxcYkjYzSZsY+mNN0/A4jjRNk6AsS2M1se87Hcch0LhtW3c+z1OK2LquGcEwDLQsC83zTH3fOzE6MLNABFVVfT0FFdVAjKKIjDG3QJO48H2fPM8TQpIkEiuyLLsFaZpSEARCstaKCB6I49gJXIeiKBwxDENH0G5PbNvGIuu6jkFQoNoTIKuJ4DUy1n9gMs+paKyQPazr+pbEKDF3iD+9CLAgXIAMD+R5bn5t/xJgAFLapBXeThz3AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image23_302_701",
    width: 31,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAQCAYAAADu+KTsAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAwFJREFUeNrEVTtMFFEUPW/mzewu+0E+q2JhKNTGmEhMjLFTChMrGwtjLAyNtVZWJiaa2IglvTYmVlY2aiGdlSQoEj4BWRDZDzi7O/8Z77uziyguEoLxbd7ct/fNO+f+3h3gPw6xn2DW3IvYbjRhN2luShsOyQ/vJzBy5xYQA4VjV8WeyRWJ73nwPR+B76Nh1eG5Hjylc11e+zQX5+ZpP0BA79lugHJpCcNXLuPizdHdkSui2U/TBECARKQIh86fRfVbGdW1MmprFSx/WYLnKFKXdVEYIQxD1sVxzDiO4yOVlsjl8wiCAPeeTwjRJlCyVq6wxZ6nSLwt02f9/PQMQjq4slhCVy6LZr3BQHEUMUlEUojO/lh1B/lcmtcPX04LOXb7EhPXv1uYmZxCZXUNzUaDc6bAlRcqrMqIthdKuo6zvYDE7rP46MbpWK6WVvD47n1WREHI4YpoQuytFnVdaxmSZFXJbDbFhtWbLgYHi1hfb/B/6drOH+5AZ2LD0FnmKHyWZTOIIjRNyWtNE0inDV4rmEQKmHSuXG3wfl9fXsUP8ndwtbn1YCpltEB/ArU9USRS6tvOdKrkqFUbbd+kSvyDa6diZTkrWmDJ1FhKqW2GcGuDMFtR2O0IguiXFsOMxWIBmi6oaslz8W+7WqG3F32HB7Aw9TEh13Xxt1TvODRd58Mq5F25HIe271ARmWwGG9Uq14QhBT7PVXHmwjBKszMYGR0XckdQKdkgw0xBGgaOnjiOjUqNyZQHavQPDKCLGodVq8FMmRAUOtM0KF0qtzFF00cc2HSTHLx+M0kGdWF5fi5JsXocPNKPQneOre/p72WLNd2kaRBwAVEsYKQyMNLZJPdErtqmrsukiKIQqUyaPKbO5nvUDV3qEXW4zTq9nehcu84RefXsKXn9TmySD507ySBRGBOhZCPCUHD3Ul1PaBQBzcLXxWUcKBbh2DYB23RZYv5QqEdlZYWl+gWtDulQo1Jj5Mm42PGr9nbsejw7tYDunjw2ahZvdDq0X+OHAAMAQxyRcKpgggUAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.5c3b21dc181dd3243afcfbba3c84dfa3.svg";
export { ForwardRef as ReactComponent };